<app-location-decisions-preview
  (onEdit)="showItemForm = true; itemForm.patchValue($event.v); currentIndex = $event.i"
  (onRemove)="onRemoveItem($event)"
  [showActions]="!disabled"
  [canEdit]="(currentIndex === undefined) && !showItemForm"
  [locationDecisions]="locationDecisions()">
</app-location-decisions-preview>
@if (showItemForm) {
  <br>
  <div class="row">
    <div class="col-12">
      <app-location-decision-item-form
        [edit]="currentIndex != undefined"
        [form]="itemForm"
        (submit)="onSubmitItemForm($event)"
        (cancel)="onCancelItemForm()">
      </app-location-decision-item-form>
    </div>
  </div>
}
<br>
@if (!showItemForm && !disabled) {
  <div class='d-flex justify-content-end'>
    <button class="btn btn-primary" type="button" (click)="showItemForm = true">
      {{ locationDecisions().length ? 'Dodaj kolejną decyzję' : 'Dodaj decyzję' }}
    </button>
  </div>
}
<br>
